import { useState } from "react";

type Props = {
  src: string;
  alt: string;
  title?: string;
  className?: string;
  wrapperClassName?: string;
};

export default function SafeImage({ src, alt, title, className = "", wrapperClassName = "" }: Props) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-2 bg-background-200 text-foreground-600 ${className} ${wrapperClassName}`}
        role="img"
        aria-label={`${alt}（图片加载失败）`}
      >
        <i className="ri-image-line text-2xl" />
        <span className="px-2 text-center text-[11px] leading-snug font-label">图片暂时无法加载</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      title={title}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}